export default "__VITE_ASSET__VOQqAF7K__"